<template>
    <div class="barImageLayout">
        <div class="imageView">
            <img :src="barImage"/>
            <div class="textDesc">
                <span>{{textDesc}}</span>
            </div>
        </div>
    </div>
</template>
<script>

import appbar from '@/assets/crmapp/appbar.png';

export default {
    data(){
        return{
            barImage:appbar,
            textDesc:'扫码下载app'
        }
    }
}
</script>
<style lang="less" scoped>
.barImageLayout{
    width: 100%;
    text-align: center;
    .imageView{
        margin-top: 140px;
        img{
            width:200px;
            height:200px;
        }
    }
    .textDesc{
        color: gray;
    }

}

</style>